import React from "react";
import Typewriter from "typewriter-effect";
import Box from "@mui/material/Box";
import InputBase from "@mui/material/InputBase";
import "./header.css";
import { useNavigate } from "react-router-dom";
import FadeIn from "react-fade-in";

const Header = () => {
  const navigate = useNavigate();
  const [signup, setSignup] = React.useState("");

  return (
    <div className="gpt3__header section__padding" id="home">
      <div className="gpt3__header-content">
        <FadeIn animateIn="fadeInDown">
          <h1 className="gradient__text">Research Smarter. Write Better.</h1>
        </FadeIn>
        <FadeIn animateIn="fadeInDown">
          <p>
            WriteAI is your AI-powered writing assistant for academic and professional documents.
            Research while you write, manage references, format citations, and get smart writing
            suggestions — all tailored to your paper type.
          </p>
        </FadeIn>
        <span style={{ fontWeight: "bold", color: "#20a3ff", margin: 20 }}>
          Get started free →
        </span>
        <form
          style={{ maxWidth: "500px" }}
          onSubmit={(e) => {
            e.preventDefault();
            navigate(`/authentication/sign-up/${signup}`);
          }}
        >
          <Box
            style={{ backgroundColor: "white" }}
            sx={{
              maxWidth: 500,
              padding: "4px",
              borderRadius: "10px",
              display: "flex",
            }}
          >
            <InputBase
              fullWidth
              sx={{ ml: 1, flex: 1 }}
              placeholder="Email Address"
              inputProps={{ "aria-label": "Email Address" }}
              value={signup}
              onChange={(e) => setSignup(e.target.value)}
              type="email"
            />
            <button style={{ border: "0px" }} type="submit">
              <span className="sign-up-button">Sign Up Free</span>
            </button>
          </Box>
        </form>
      </div>

      <div
        style={{
          backgroundColor: "rgb(4 44 84)",
          color: "white",
          flex: 1,
          borderRadius: 10,
          padding: 20,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="gpt3__header-image">
          <Typewriter
            options={{ loop: true }}
            onInit={(typewriter) => {
              typewriter
                .typeString('Write your next <strong><span style="color: #20d2ff;">Research Paper</span></strong>')
                .pauseFor(1800)
                .deleteAll()
                .typeString('Structure a <strong><span style="color: #27ae60;">Business Report</span></strong>')
                .pauseFor(1800)
                .deleteAll()
                .typeString('Draft a thorough <strong><span style="color: #e67e22;">Literature Review</span></strong>')
                .pauseFor(1800)
                .deleteAll()
                .typeString('Analyse a compelling <strong><span style="color: #8e44ad;">Case Study</span></strong>')
                .pauseFor(1800)
                .deleteAll()
                .typeString('Document a <strong><span style="color: #e74c3c;">Technical Report</span></strong>')
                .pauseFor(1800)
                .deleteAll()
                .start();
            }}
          />
        </div>
        <strong
          style={{
            justifyContent: "end",
            alignItems: "end",
            flex: 1,
            display: "flex",
            color: "white",
            fontSize: "small",
            marginTop: "15px",
          }}
        >
          @ WriteAI {new Date().getFullYear()}
        </strong>
      </div>
    </div>
  );
};

export default Header;
